// @ts-nocheck
/* Port of CkEditorField.js (24L). BYTE-IDENTICAL. */
import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const CkEditorField = ({ value, onChange }: any) => (
  <div className="rc-ckeditor">
    <CKEditor
      editor={ClassicEditor}
      data={value || ''}
      onChange={(event: any, editor: any) => onChange(editor.getData())}
      onReady={(editor: any) => {
        editor.editing.view.change((writer: any) => {
          writer.setStyle(
            'min-height',
            '320px',
            editor.editing.view.document.getRoot(),
          );
        });
      }}
    />
  </div>
);

export default CkEditorField;
